import { cls } from './classes.js';
import { color } from '../tokens.js';

/**
 * The loading sign (owner, 4 October 2026: a spinning ring instead of "Loading…" words). The words stay,
 * for screen readers only, inside whatever status element holds the ring.
 */
export function Spinner({ label, size = 26 }: { readonly label: string; readonly size?: number }) {
  return <span data-v1-spinner="" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    <span aria-hidden="true" className={cls('spin')} style={{ display: 'block', width: size, height: size, boxSizing: 'border-box', borderRadius: '50%', border: '2.5px solid rgba(233, 237, 245, 0.18)', borderTopColor: color.paper }} />
    <span className={cls('srOnly')}>{label}</span>
  </span>;
}
